<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="Partno">1</p>
<p class="sectit">Basic Techniques</p>
<p class="introtxt"><i>This is the start of your simple softie journey! Within this section, I cover the project preparation phase. It’s best to have everything at hand before starting to cut and sew.</i></p>
<p class="image"><img alt="" src="images/pg10_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_part01.vue?75f36bd6